// services/ReviewFolder/review.service.local.js
export const reviewService = {
  async query(filterBy = {}) {
    console.log('Fetching local reviews with filter:', filterBy)
    return [] // מחזיר מערך ריק כרגע
  },

  async getById(reviewId) {
    console.log(`Fetching local review with ID: ${reviewId}`)
    return null
  },

  async save(review) {
    console.log('Saving review locally:', review)
    return review
  },

  async remove(reviewId) {
    console.log(`Removing local review with ID: ${reviewId}`)
    return reviewId
  },
}
